import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { DividerComponent } from 'src/app/modules/shared/design-system/divider/divider.component';
import { IconWrapperComponent } from 'src/app/modules/shared/design-system/icon/icon-wrapper.component';
import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmationService } from './confirmation.service';

@NgModule({
    imports: [CommonModule, MatIconModule, FormsModule, IconWrapperComponent, DividerComponent],
    declarations: [ConfirmDialogComponent],
})
export class LibConfirmationModule {
    static forRoot(): ModuleWithProviders<LibConfirmationModule> {
        return {
            ngModule: LibConfirmationModule,
            providers: [ConfirmationService],
        };
    }
}
